/**
 * Pre-compiled localized messages for Alert component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import alertMessages_en from "./intl/en";
import alertMessages_de from "./intl/de";
import alertMessages_es from "./intl/es";
import alertMessages_fr from "./intl/fr-FR";
import alertMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const alertMessagesStrings: LocalizedStrings<string, LocalizedString> = {
  en: normalizeMessages(alertMessages_en),
  de: normalizeMessages(alertMessages_de),
  es: normalizeMessages(alertMessages_es),
  "fr-FR": normalizeMessages(alertMessages_fr),
  "pt-BR": normalizeMessages(alertMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for Alert component
 */
export type AlertMessageKey = "dismiss";
